/* eslint-disable check-file/filename-blocklist */
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResultsInfoContainer = styled.span({
	position: 'relative',
	display: 'flex',
	height: '20px',
	paddingTop: token('space.050'),
	paddingBottom: token('space.100'),
	font: token('font.body.small'),
	color: token('color.text.subtlest'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ResultsCountContainer = styled.span({
	height: '20px',
	outline: 'none',
	color: token('color.text.subtle'),
});
